const formPopup = document.querySelector(`.form-popup`);

if (formPopup) {
  const sendMessage = document.querySelector(`#sendMessage`);
  const formOverlay = formPopup.querySelector(`.form-popup__overlay`);

  const openFormPopup = (evt) => {
    evt.preventDefault();
    formPopup.classList.toggle(`form-popup--visible`);
  }

  const closeFormPopup = () => {
    formPopup.classList.toggle(`form-popup--visible`);
  }

  sendMessage.addEventListener(`click`, openFormPopup);
  formOverlay.addEventListener(`click`, closeFormPopup);
}